import { BaseValidator } from './baseValidator';
import ValidationErrors from '../fields/validationErrors';

export class CityFieldValidator extends BaseValidator {
    public EUCityLengthRule(value: string) {
        const MAX_LENGTH = 255;

        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                rule: 'EUCityLengthRule',
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
            };
        }

        return null;
    }

    public JPCityLengthRule(value: string) {
        const MAX_LENGTH = 85;

        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                rule: 'JPCityLengthRule',
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
            };
        }

        return null;
    }
}
